export default __webpack_public_path__ + "rejected-active.svg";